import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    data: '[]',
};

const getters = {
    data: state => JSON.parse(state.data),
};

const mutations = {
    setData(state, data) {
        state.data = data;
    },
};

const actions = {
    async getReport({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.eod.report.list', { id });

        startLoading(dispatch, 'get-report');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'get-report');
            commit('setData', data.inventory);
            return data;
        } catch (e) {
            endLoading(dispatch, 'get-report');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventory-eod-report.js